var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section", attrs: { id: "professionals" } }, [
    _c("div", { staticClass: "section-title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
      _c("hr")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section-body" },
      _vm._l(_vm.professionals, function(professional) {
        return _c(
          "div",
          {
            key: professional.id,
            staticClass: "professional",
            class: { checked: _vm.professional_id == professional.id },
            on: {
              click: function($event) {
                _vm.setProfessionalId(professional.id)
                _vm.$emit("scrollTo", "#informations")
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("../../../../static/user-default.svg") }
            }),
            _vm._v(" "),
            _vm._m(0, true),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(professional.name))]),
            _vm._v(" "),
            _c("small", [
              _vm._v(_vm._s(professional.clears_count) + " limpezas")
            ]),
            _vm._v(" "),
            _c("img", {
              attrs: { src: require("../../../../static/stars.svg") }
            })
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hovered" }, [
      _c("div", { staticClass: "icon-check" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0347e35c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0347e35c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/OrdersAndSubscriptions/Professionals.vue
// module id = null
// module chunks = 